(function () {
  'use strict';

  var link = document.querySelector('[data-nbr-rewards-link]');
  if (!link) return;

  link.addEventListener('click', function (event) {
    var retonButton = document.getElementById('reton-reward-button');
    if (retonButton) {
      var openTrigger = retonButton.querySelector('.reton-button-open') || retonButton;
      event.preventDefault();
      openTrigger.click();
      return;
    }
    // Reton widget not present/loaded yet: fall through to the real href
    // (the Goodness Rewards page), no fake state is shown.
  });
})();
